<ng-container *ngFor="let author$ of authors$">
    <ng-container *ngIf="(author$ | async) as author">
        <h6>{{author.name}}</h6>
        <p [innerHTML]="author.body"></p>
    </ng-container>
</ng-container>